module.exports = __webpack_public_path__ + "static/media/kubernetes.138130eb.png";